// extracted by mini-css-extract-plugin
export default {"list":"s4U0P","stack":"dQkVx","cardControls":"JRuFb"};